




import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Rates from '@/components/rates/Rates.vue';
import AccountsTable from '@/components/accounts/AccountsTable.vue';
import CounterList from '@/components/counters/CounterList.vue';
import SingleCounter from '@/components/counters/SingleCounter.vue';
import CounterLogs from '@/components/counters/CounterLogs.vue';
import Providers from '@/components/providers/Providers.vue';
import Buildings from '@/components/buildings/Buildings.vue';
import RatesComponent from '@/components/rates/RatesComponent.vue';
import { RatesModule } from '@/store/dashboard/rates/RatesModule';
import MenuTabs from '@/components/menu-tabs/MenuTabs.vue';
import { resolveModule } from '@/store';
import BillingReportComponent from '@/components/billing/BillingReportComponent.vue';
import { BuildingsModule } from '@/store/dashboard/buildings/BuildingsModule';

@Component({
  components: {
    rates: Rates,
    'accounts-table': AccountsTable,
    'counter-list': CounterList,
    'single-counter': SingleCounter,
    'counter-logs': CounterLogs,
    providers: Providers,
    buildings: Buildings,
    'rates-component': RatesComponent,
    'menu-tabs': MenuTabs,
    'billing-report-component': BillingReportComponent
  }
})
export default class Single extends Vue {
  /* eslint-disable */
  private readonly ratesModule: RatesModule = resolveModule(RatesModule);
  private readonly buildingModule: BuildingsModule = resolveModule(BuildingsModule);

  private get building() {
    return this.buildingModule.BuildingById(9);
  }

  private get rates() {
    return this.ratesModule.rates;
  }

  private async mounted() {
    await this.ratesModule.fetchForAccount(3);
    await this.buildingModule.FetchSingle(9);
    // await this.fetchCountersByAccountId(4);
  }
}
